import { render } from "./CircleProgress.vue?vue&type=template&id=af0a0ca6"
import script from "./CircleProgress.vue?vue&type=script&lang=js"
export * from "./CircleProgress.vue?vue&type=script&lang=js"

import "./CircleProgress.vue?vue&type=style&index=0&id=af0a0ca6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__